import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { InterFrameCommModule } from '@vapor/angular-core';
import {
    INTERFRAME_BIZ_HANDLER_TOKEN,
    INTERFRAME_GLOBAL_CONFIG,
    INTERFRAME_MESSAGE_OUTBOUND_TOKEN
} from './interframe-global.model';
import { InterframeGlobalService } from './interframe-global.service';
import { InterframeOtherHandlerService } from './other-handler/interframe-other-handler.service';
import { InterframeViaLyberaService } from './via-lybera/interframe-via-lybera.service';

export const initializeInterframeService = (
    service: InterframeGlobalService
) => {
    return () => {
        // Service is instantiated just by injecting it
        return service;
    };
};

@NgModule({
    declarations: [],
    imports: [InterFrameCommModule],
    providers: [
        {
            provide: 'interFrameConfig',
            useValue: INTERFRAME_GLOBAL_CONFIG
        },
        InterframeGlobalService,
        {
            provide: INTERFRAME_MESSAGE_OUTBOUND_TOKEN,
            useClass: InterframeViaLyberaService
        },
        {
            provide: INTERFRAME_BIZ_HANDLER_TOKEN,
            useClass: InterframeViaLyberaService,
            multi: true
        },
        {
            provide: INTERFRAME_BIZ_HANDLER_TOKEN,
            useClass: InterframeOtherHandlerService,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeInterframeService,
            deps: [InterframeGlobalService],
            multi: true
        }
    ]
})
export class InterframeGlobalModule {
    constructor(@Optional() @SkipSelf() parentModule?: InterframeGlobalModule) {
        if (parentModule) {
            throw new Error(
                'InterframeGlobalModule is already loaded. Import it in the AppModule only.'
            );
        }
    }
}
